<template>
  <SPassengersSelection
    :adultsAmount="getAdults"
    :childrenAmount="getChildren"
    :vehicleCategoryId="getVehicleCategoryId"
    :vehicleCategories="getVehicleCategories"
    :appConfig="appConfig"
    :wheelchairPlacesAmount="getWheelchairPlacesAmount"
    @updateAdults="updateAdults"
    @updateChildren="updateChildren"
  />
</template>
<script lang="ts">
export default {
  name: 'PassengersSelection',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { SPassengersSelection, SConstants } from '@slg/web-customer-shared';
import importedAppConfig from '@/appConfig';
import { useStore } from '@/composables';

const emit = defineEmits(['clearBookingRequestError']);
const store = useStore();
const appConfig = ref<Record<string, any>>({});
const show = ref(false);
appConfig.value = importedAppConfig;

const getAdults = computed(() => store.getters['booking/getAdults']);
const getChildren = computed(() => store.getters['booking/getChildren']);
const getVehicleCategoryId = computed(() => store.getters['booking/getVehicleCategoryId']);
const getVehicleCategories = computed(() => store.getters['opsZone/getVehicleCategories']);
const getSelectedFeatures = computed(() => store.getters['booking/getSelectedFeatures']);
const getWheelchairPlacesAmount = computed(() => {
  const wheelChairFeature = getSelectedFeatures.value?.find(
    (feature: { vehicleFeatureId: string }) => feature.vehicleFeatureId === SConstants.WHEELCHAIR_PLACE_ID,
  );
  return wheelChairFeature?.amount;
});

function updateAdults(newValue: number) {
  store.commit('booking/setAdults', newValue);
  emit('clearBookingRequestError');
}

function updateChildren(newValue: number) {
  emit('clearBookingRequestError');
  store.commit('booking/setChildren', newValue);
}
</script>

<style scoped>

</style>
